export const importerCardStyles = {
  optionCard: {
    borderRadius: '10px',
    padding: '10px 10px 0 10px',
  },
  cardHeader: {
    paddingBottom: '0',
  },
  cardAction: {
    margin: '0 5px',
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
  },
  columnPhoto: {
    display: 'flex',
    width: { xs: '50%', sm: '45%' },
    justifyContent: 'center',
    alignItems: 'center',
  },
  columnDetails: {
    width: { xs: '50%', sm: '55%' },
  },
  image: {
    width: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  contactBox: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '5px',
    marginBottom: '5px',
  },
  contactValue: {
    marginLeft: '10px',
    whiteSpace: 'pre-line',
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  },
};
